import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { AuAssetElementComponent } from './au-asset-element.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
	imports: [
		CommonModule,
		DragDropModule,
		MatIconModule,
		MatCheckboxModule,
		AuAssetElementComponent,
	],
	exports: [AuAssetElementComponent],
})
export class AuAssetElementModule {}
